import React, { useRef } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Link } from "react-router-dom";
import { HiMiniRocketLaunch } from "react-icons/hi2";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import { gameData } from "../helpers/gamelist";
import WrapperTitle from "./WrapperTitle";
import { useTranslation } from "react-i18next";
import i18n from "../../src/i18n/i18n";
import { stylesConfig, typeIconConfig } from "../helpers/stylesConfig";
import { BiSolidTag } from "react-icons/bi";
import NewGameTag from "./NewGameTag";
import LazyImage from "../pages/components/Loading/LazyImage";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { COMMON_ALT } from "../constant";

const AllGameCarousel = ({ tag, type }) => {
  const { t, i18n: i18nInstance } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const currentLang = i18nInstance.language || "en";
  const currentGameData = gameData(currentLang); // 獲取當前語言的遊戲數據

  const splideRef = useRef(null);

  const slideLeft = () => {
    if (splideRef.current) {
      splideRef.current.go("<"); // 向左滑动一个幻灯片
    }
  };

  const slideRight = () => {
    if (splideRef.current) {
      splideRef.current.go(">"); // 向右滑动一个幻灯片
    }
  };

  return (
    <section
      className={`text-center ${type === "Slot" ? "mt-0" : "mt-2 md:mt-6"}`}
    >
      <div className="flex justify-between items-center mb-2 md:mb-4">
        <WrapperTitle
          icon={
            type ? (
              <img
                src={typeIconConfig[type]}
                alt={type}
                className="w-8 h-8 md:w-14 md:h-14"
              />
            ) : (
              <HiMiniRocketLaunch />
            )
          }
          // icon={<HiMiniRocketLaunch />}
          //title={`${tag || ""} Products`}
          title={type ? `${i18n(type)}` : i18n("Products")} // 通过type来判断是否有type，有的话就显示type，没有的话就显示Products
        />
        <div className="flex flex-row items-center">
          {/* <Link to={`/products/${type}`}>
            <div className="view-all-button mr-2">
              {i18n("View")}
              {type ? ` ${i18n(type)}` : ""}
              
            </div>
          </Link> */}
          <div
            className=" rounded-xl splide-arrow-button h-[35px] w-[35px] mr-2 flex justify-center items-center"
            onClick={slideLeft}
          >
            <MdArrowBackIosNew className="text-[#726190] text-2xl p-1 font-extrabold" />
          </div>
          <div
            className="rounded-xl splide-arrow-button h-[35px] w-[35px] mr-2 flex justify-center items-center"
            onClick={slideRight}
          >
            <MdArrowForwardIos className="text-[#726190] text-2xl p-1 font-extrabold" />
          </div>
        </div>
      </div>
      <Splide
        ref={splideRef}
        aria-label="New Products"
        className=" w-full overflow-hidden"
        options={{
          type: "slide",
          perPage: 7,
          gap: 15,
          autoplay: false,
          arrows: false,
          drag: "free",
          perMove: 1,
          pagination: false,
          lazyLoad: "nearby",
          dragMinThreshold: {
            mouse: 0,
            touch: 10,
          },
          preloadPages: 7,
          keyboard: false,
          breakpoints: {
            640: {
              perPage: 2,
              gap: 5,
            },
            768: {
              perPage: 4,
              gap: 5,
            },
            1024: {
              perPage: 5,
            },
            1280: {
              perPage: 7,
            },
          },
        }}
      >
        {currentGameData
          .filter((item) => {
            if (type) {
              return item.type === type;
            } else {
              return item;
            }
          })
          .map((game, index) => (
            <SplideSlide key={index} className="rounded-xl">
              <div className="gameSlide-container">
                <NewGameTag game={game} />
                <div className="hidden md:block">
                  <LazyLoadImage
                    src={game.image}
                    alt={game.title}
                    className="hidden md:block rounded-[20px] md:rounded-[30px] object-cover w-full h-[170px]"
                    data-splide-lazy="path-to-the-image"
                  />
                </div>
                <div className="md:hidden">
                  <LazyLoadImage
                    src={game.image_mobile}
                    alt={game.title}
                    className="block md:hidden rounded-[20px] md:rounded-[30px] object-cover w-full h-[150px]"
                    data-splide-lazy="path-to-the-image"
                  />
                </div>
                <div className="mt-2 text-center">
                  <p className="text-black text-sm font-medium md:hidden text-left px-2">
                    {i18n(game.title)}
                  </p>
                </div>
                <div className="overlay rounded-[20px] md:rounded-[30px]">
                  <div className="overlay-content">
                    <p>{i18n(game.title)}</p>
                    <Link to={`/play/${game.uid}`}>
                      <div className="play-button rounded-[5px] !px-[8px] !py-[6px] !mb-2 max-w-[130px] !mx-auto">
                        {i18n("Play Demo")}
                      </div>
                    </Link>
                    <Link to={game.Morelink}>
                      <div className="more-button rounded-[5px] !px-[8px] !py-[6px] max-w-[130px] !mx-auto">
                        {i18n("Read More")}
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </SplideSlide>
          ))}
        <SplideSlide className="rounded-xl">
          <div className="gameSlide-container">
            <div className="bg-base-deep-gray rounded-xl object-cover w-full h-[170px] flex flex-col justify-center items-center">
              <img
                src={stylesConfig.mainLogo}
                alt={COMMON_ALT}
                className="w-[80px] logo-drop-shadow"
                style={{ WebkitFilter: "brightness(1.5)" }}
              />
              <p className="text-light-gray m-2">{i18n("Coming Soon")}</p>
            </div>

            <div className="overlay rounded-xl">
              <div className="overlay-content">
                <p>{i18n("Coming Soon")}</p>
                <Link to="/products">
                  <div className="more-button rounded-[5px] !px-[8px] !py-[6px]">
                    {i18n("Read More")}
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </SplideSlide>
      </Splide>
    </section>
  );
};

export default AllGameCarousel;
